import { defineComponent as k, ref as p, computed as T, watch as S, createElementBlock as s, openBlock as d, normalizeStyle as h, normalizeClass as n, unref as t, createCommentVNode as i, createElementVNode as r, createStaticVNode as B, withDirectives as E, renderSlot as a, createVNode as y, vShow as C } from "vue";
import { useResizeObserver as I, useMediaQuery as b } from "@vueuse/core";
import { EDITOR_ID as P, DocumentClasses as c, EditorClasses as N } from "@scalar-org/css";
import V from "./components/PageNav.vue.js";
import "./components/PageNav.vue2.js";
import D from "./components/TableOfContents.vue.js";
const G = ["id"], z = {
  key: 0,
  class: "layout-header"
}, O = {
  key: 1,
  class: "layout-aside-content"
}, R = ["id"], L = { class: "layout-aside-right" }, M = { class: "layout-footer" }, J = /* @__PURE__ */ k({
  __name: "ApiGuide",
  props: {
    activePage: {},
    editorViewportId: {},
    showSidebar: { type: Boolean },
    footerBelowSidebar: { type: Boolean },
    sidebar: {},
    headings: {},
    isLoaded: { type: Boolean }
  },
  emits: ["goToNextPage", "goToPrevPage"],
  setup(w) {
    const u = w, m = p(0), g = p(null);
    I(g, (e) => {
      m.value = e[0].contentRect.height;
    });
    const f = b("(max-width: 1120px)"), l = b("(max-width: 1000px)"), $ = T(() => `Guide / ${u.activePage?.title}`);
    return S(
      () => u.activePage?.uid,
      () => {
        const e = document.getElementById(P);
        e && (e.scrollTop = 0);
      }
    ), (e, o) => (d(), s("main", {
      id: t(P),
      ref_key: "documentEl",
      ref: g,
      class: n({
        [t(c).Document]: !0,
        "footer-below-sidebar": e.footerBelowSidebar,
        "hide-aside-right": t(f)
      }),
      style: h({ "--full-height": `${m.value}px` })
    }, [
      t(l) ? i("", !0) : (d(), s("div", z, [
        a(e.$slots, "header", {}, void 0, !0)
      ])),
      r("aside", {
        class: n(["layout-aside-left", t(c).Sidebar])
      }, [
        t(l) ? a(e.$slots, "mobile-header", {
          key: 0,
          label: $.value
        }, void 0, !0) : i("", !0),
        e.showSidebar || !t(l) ? (d(), s("div", O, [
          t(l) ? a(e.$slots, "header", { key: 0 }, void 0, !0) : i("", !0),
          a(e.$slots, "guide-sidebar", {}, void 0, !0)
        ])) : i("", !0)
      ], 2),
      o[2] || (o[2] = B('<div class="section-flare-guide" data-v-9774e508><div class="section-flare" data-v-9774e508><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div></div></div>', 1)),
      e.activePage?.backgroundImage ? (d(), s("div", {
        key: 1,
        class: "layout-image",
        style: h(`background-image: url(${e.activePage.backgroundImage})`)
      }, null, 4)) : i("", !0),
      E(r("div", {
        class: n(["editor layout-content", t(N).Editor])
      }, [
        a(e.$slots, "editor-content", {}, void 0, !0),
        y(V, {
          activePage: e.activePage,
          sidebar: e.sidebar,
          onGoToNextPage: o[0] || (o[0] = (v) => e.$emit("goToNextPage", v)),
          onGoToPrevPage: o[1] || (o[1] = (v) => e.$emit("goToPrevPage", v))
        }, null, 8, ["activePage", "sidebar"]),
        r("div", {
          id: e.editorViewportId,
          class: "layout-content-viewport"
        }, null, 8, R)
      ], 2), [
        [C, e.isLoaded]
      ]),
      r("aside", L, [
        t(f) ? i("", !0) : (d(), s("div", {
          key: 0,
          class: n(["custom-scroll custom-scroll-self-contain-overflow", [t(c).TableOfContents]])
        }, [
          y(D, {
            headings: e.headings,
            pageTitle: e.activePage?.title || ""
          }, null, 8, ["headings", "pageTitle"])
        ], 2))
      ]),
      r("div", M, [
        a(e.$slots, "footer", {}, void 0, !0)
      ])
    ], 14, G));
  }
});
export {
  J as default
};
